// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"242e2356","891":"42c52c7c"}[chunkId] + ".chunk.css";
};